import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

export interface CoverageTableColumn {
  labelKey: string;
  numeric?: boolean;
}

@Component({
  selector: 'app-coverage-table-head',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {class: 'table-header-group'},
  imports: [TranslocoPipe],
  templateUrl: './coverage-table-head.component.html',
})
export class CoverageTableHeadComponent {
  readonly columns = input.required<CoverageTableColumn[]>();
}
